import React, { useState } from 'react';

const TestimonialSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      image: '/profile1.jpg',
      text: '"Alee Club gives me a golden opportunity to showcase my talent and thus taught me to be proficient by giving the Miss India competent. This is such a numerous platform from where a number of generous personalities came up and working in the Bollywood industry today."',
      name: 'Shriya Ghose'
    },
    {
      image: '/profile2.jpg',
      text: '"My journey was very wonderfull. I will never forget the nine days of training. Those memories are in my heart. Sambita Bose Ma\'am is very cheery. She taught us and i can say with full confidence that i am here today because of Alee Club. Thank you so much. Alee Club, for making me capable."',
      name: 'Shalini Kumari'
    },
    {
      image: '/profile5.jpg',
      text: '"Since the first day training, I have felt happiness running through me because hard work makes me happy. i know the Alee Club has showered us with immense love and support, helping us to achieve our goals and our dreams."',
      name: 'Rifkah Das Gupta'
    },
    {
      image: '/profile3.jpg',
      text: '"Being a contestant of Alee Club Miss Teen India. I personally think this is the best platform for a person to grow in the field of modeling. I want to thank for showering love and support on me."',
      name: 'Sanskritii Sahay'
    }
  ];

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-bold text-2xl md:text-3xl mb-12 text-gray-900">
          What <span className="text-red-600">Students Say</span> About Us
        </h2>

        <div className="relative max-w-4xl mx-auto">
          {/* Testimonial Content */}
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-20 px-4">
            <img
              src={testimonials[activeIndex].image}
              alt={testimonials[activeIndex].name}
              className="w-20 h-20 md:w-28 md:h-28 rounded-full object-cover shadow-xl border-4 border-red-100"
            />
            <div className="text-left max-w-2xl">
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed italic">
                {testimonials[activeIndex].text}
              </p>
              <h6 className="font-bold text-base md:text-lg text-gray-900">
                — {testimonials[activeIndex].name}
              </h6>
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={handlePrev}
            className="hidden md:block absolute left-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={handleNext}
            className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>

          {/* Dots Indicators */}
          <div className="flex items-center justify-center gap-2 bg-gray-100 rounded-full px-5 py-3 inline-flex">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => handleDotClick(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === activeIndex
                    ? 'bg-black scale-110'
                    : 'bg-gray-400 hover:bg-gray-600'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;